/**
 * AccentMask component
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Bottom green-tinted gradient mask.
 */
const AccentMask = styled.div`
  background: linear-gradient(
    171deg,
    rgba(0, 0, 0, 0) 60%,
    rgba(80, 227, 194, 0.2) 70%,
    rgba(80, 227, 194, 0.4) 80%,
    rgba(80, 227, 194, 0.7) 93%,
    rgb(80, 227, 194) 100%
  );
  bottom: 0;
  height: ${490 * Screen.widthRatio}px;
  left: 0;
  position: absolute;
  width: ${1920 * Screen.widthRatio}px;
  z-index: 1;
`;

export default withOpacity(AccentMask);
